import Flash from './Flash'

const Tickets = (() => {
  const manager = {
    els: document.querySelectorAll('.js-ticket'),
    instances: [],

    onSuccess: function (_, data) {
      const image = data.thumbnail || document.querySelector('meta[name="user_image_default"]').getAttribute('content')

      const row = `<div class="c-ticket__row c-ticket__row--reverse">
        <div class="c-ticket__user">
          <img class="c-ticket__user-img" src="${image}"/>
          <div class="c-ticket__user-name">${data.user}</div>
        </div>

        <div class="c-ticket__message">${data.message.replace(/\n/g, '<br>')}</div>
      </div>`

      _.content.innerHTML += row

      _.form.classList.remove('is-open')
      _.replyButton.innerText = 'Reply'
      _.input.value = ''
      _.isFormOpen = false
    },

    onSubmit: function (_, e) {
      // const data = {user: 'Mario Rossi', message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id turpis odio. Cras rutrum eget enim vestibulum varius.', thumbnail: ''}

      // if (true) {
      //   this.onSuccess(_, data)
      // } else {
      //   alert('error')
      // }

      if (!_.input.value || _.input.value === '') {
        e.preventDefault()
      }
    },

    onSubmitSuccess: function (_, e) {
      const response = e.detail[0]

      if (response.result) {
        this.onSuccess(_, {
          message: _.input.value,
          user: response.user_complete_name,
          thumbnail: response.user_image_profile
        })
      } else {
        Flash.danger(response.error)
      }
    },

    initInstances: function () {
      // add listeners etc
      this.instances.forEach(_ => {
        if (_.form && _.replyButton && _.submitButton) {
          _.replyButton.addEventListener('click', () => {
            if (!_.isFormOpen) {
              _.form.classList.add('is-open')
              _.replyButton.innerText = 'Send'
              _.isFormOpen = true
            } else {
              _.submitButton.click()
            }
          })

          _.form.addEventListener('submit', e => {
            this.onSubmit(_, e)
          })

          _.form.addEventListener('ajax:success', e => {
            this.onSubmitSuccess(_, e)
          })
        }
      })
    },

    init: function () {
      if (this.els.length) {
        this.onSubmit = this.onSubmit.bind(this)
        this.onSuccess = this.onSuccess.bind(this)

        this.els.forEach(el => {
          const form = el.querySelector('.js-ticket-form')
          const input = el.querySelector('.js-ticket-input')
          const submitButton = el.querySelector('.js-ticket-submit')
          const replyButton = el.querySelector('.js-ticket-reply')
          const closeButton = el.querySelector('.js-ticket-close')
          const content = el.querySelector('.js-ticket-content')
          let isFormOpen = false

          this.instances.push({
            el,
            form,
            input,
            submitButton,
            replyButton,
            closeButton,
            content,
            isFormOpen
          })
        })

        this.initInstances()
      }
    }
  }

  const init = () => {
    manager.init()
  }

  return {
    init
  }
})()

export default Tickets


// WEBPACK FOOTER //
// app/javascript/scripts/components/Tickets.js